// 更改页脚的域名、协议, 用于审查
// 2024.08.23 邓智轩：送审域名+对应游戏+带参数p=rupay时替换服务条款链接
import globalConfig from '@utiles/officialStore/globalConfig';
const mainHost = globalConfig.getMainHost();
// 1、域名mcdofficial、pnsofficial、antlegion、lokitopfun + 参数p=rupay ：改页脚文案、改条款链接
export const gameDomainMap = {
  // v2
  295: 'mcdofficial.com',
  // v1
  285: 'lokitopfun.com',
  191: 'pnsofficial.com',
  263: 'antlegion.com'
};
// 2、域名endomainname、goeofficial + gameid=269 + 参数p=rupay ：改页脚文案、改条款链接（文案和链接与1不一样，是单独的一份）
export const domainGameMap = {
  'endomainname.com': 269,
  'goeofficial.com': 269
};
// 3  、域名window.atob('MzdnYW1lcw==') + gameid=[285,191,263,295,339,175,331] + 非日语 ：只改页脚文案（不需要参数p=rupay）
export const gameDomainFooterMap = {
  // v3
  456: window.atob('Z25qb3kuZ2FtZQ=='),
  386: window.atob('Z25qb3kuaGs='),
  // v2
  295: window.atob('MzdnYW1lcy5jb20='),
  339: window.atob('MzdnYW1lcy5jb20='),
  175: window.atob('MzdnYW1lcy5jb20='),
  331: window.atob('MzdnYW1lcy5jb20='),
  // v1
  285: window.atob('MzdnYW1lcy5jb20='),
  191: window.atob('MzdnYW1lcy5jb20='),
  263: window.atob('MzdnYW1lcy5jb20=')
};
// 2024-08-29 4、由于295后端重定向了，所以加上 gameId=295 + 域名window.atob('MzdnYW1lcw==') 跳转规则

export const getCopyright = gameId => {
  let winLang = '';
  if (window.navigator) {
    winLang =
      globalConfig.getLanguages() ||
      window.navigator.language ||
      window.navigator.browserLanguage ||
      window.navigator.systemLanguage;
  } else {
    winLang = globalConfig.getLanguages();
  }
  let copyright = ``;
  let year = new Date().getFullYear();
  // 3
  if (mainHost === gameDomainFooterMap[+gameId] && winLang !== 'ja-JP') {
    if ([386, 456].includes(+gameId)) {
      copyright = `© Gravity Co.,Ltd. & LeeMyoungJin(studio DTDS) All rights reserved.`;
    } else {
      copyright = `© ${year} ${window.atob('MzdHQU1FUw==')} ENTERTAINMENT LIMITED ALL RIGHTS RESERVED.<br>
    RM 702 KLN BLDG 555 NATHAN RD KL Hong Kong`;
    }
  }
  // 1
  if (
    mainHost === gameDomainMap[+gameId] &&
    globalConfig.getHrefParam('p') == 'rupay'
  ) {
    copyright = `© ${year} ${window.atob('MzdHQU1FUw==')} ENTERTAINMENT LIMITED ALL RIGHTS RESERVED.<br>
    RM 702 KLN BLDG 555 NATHAN RD KL Hong Kong`;
  }
  // 2
  if (
    +gameId === domainGameMap[mainHost] &&
    globalConfig.getHrefParam('p') == 'rupay'
  ) {
    copyright = `©️ ${year} DROUPNIR ENTERTAINMENT LIMITED ALL RIGHTS RESERVED.<br>
    RM 702 KLN BLDG 555 NATHAN RD KL Hong Kong`;
  }
  return copyright;
};

export const getPrivacyLink = gameId => {
  // 1
  if (
    mainHost === gameDomainMap[+gameId] &&
    globalConfig.getHrefParam('p') == 'rupay'
  ) {
    return `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=privacy_rupay`;
  }
  // 2
  if (
    +gameId === domainGameMap[mainHost] &&
    globalConfig.getHrefParam('p') == 'rupay'
  ) {
    return 'https://gpassport.goeofficial.com/center/ServicePrivacy/customize?keyWord=privacy_rupay';
  }
  // 4
  if (mainHost === window.atob('MzdnYW1lcy5jb20=') && +gameId === 295) {
    return `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=privacy_rupay`;
  }
  return '';
};

export const getServiceLink = gameId => {
  // 1
  if (
    mainHost === gameDomainMap[+gameId] &&
    globalConfig.getHrefParam('p') == 'rupay'
  ) {
    return `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=service_rupay`;
  }
  // 2
  if (
    +gameId === domainGameMap[mainHost] &&
    globalConfig.getHrefParam('p') == 'rupay'
  ) {
    return 'https://gpassport.goeofficial.com/center/ServicePrivacy/customize?keyWord=service_rupay';
  }
  // 4
  if (mainHost === window.atob('MzdnYW1lcy5jb20=') && +gameId === 295) {
    return `https://gpassport.${window.atob('MzdnYW1lcy5jb20=')}/center/ServicePrivacy/customize?keyWord=service_rupay`;
  }
  return '';
};
